import { StarRating } from 'components/Blocks/Reviews/StarRating';
import useTranslation from 'next-translate/useTranslation';
import { ReviewsSummary } from 'types/review';

type textType = 'fullText' | 'countOnly';

export type ReviewSummaryPreviewProps = {
    summary: ReviewsSummary;
    textType?: textType;
};

export const ReviewSummaryPreview = ({ summary, textType = 'fullText' }: ReviewSummaryPreviewProps) => {
    const { t } = useTranslation();

    const reviewsText =
        textType === 'fullText'
            ? t('{{ count }} reviews', { count: summary.totalCount })
            : t('({{ reviewsCount }})', { reviewsCount: summary.totalCount });

    return (
        <div className="space-between flex items-center space-x-1">
            <StarRating rating={summary.averageRating} type="normal" />
            <div>{reviewsText}</div>
        </div>
    );
};
